<div class="support-ticket-modal__container">
  <div class="support-ticket-modal__header">
    <h2 class="support-ticket-modal__title">Raise a support ticket</h2>
    <button class="support-ticket-modal__close" (click)="onClose()" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="support-ticket-modal__content" *ngIf="!isSuccess">
    <form [formGroup]="supportForm" (ngSubmit)="onSubmit()" class="support-ticket-modal__form">
      
      <div class="support-ticket-modal__field">
        <label class="support-ticket-modal__label" for="name">Name</label>
        <input 
          class="support-ticket-modal__input" 
          id="name"
          type="text" 
          formControlName="name"
          placeholder="Enter your name">
        <div class="support-ticket-modal__error" *ngIf="supportForm.get('name')?.touched && supportForm.get('name')?.errors?.['required']">
          Name is required
        </div>
      </div>

      <div class="support-ticket-modal__field">
        <label class="support-ticket-modal__label" for="email">Email</label>
        <input 
          class="support-ticket-modal__input" 
          id="email"
          type="email" 
          formControlName="email"
          placeholder="Enter your email">
        <div class="support-ticket-modal__error" *ngIf="supportForm.get('email')?.touched && supportForm.get('email')?.errors?.['required']">
          Email is required
        </div>
        <div class="support-ticket-modal__error" *ngIf="supportForm.get('email')?.touched && supportForm.get('email')?.errors?.['email']">
          Please enter a valid email
        </div>
      </div>

      <div class="support-ticket-modal__field">
        <label class="support-ticket-modal__label" for="message">Message</label>
        <textarea 
          class="support-ticket-modal__textarea" 
          id="message"
          formControlName="message"
          placeholder="Describe your issue or question"
          rows="4"></textarea>
        <div class="support-ticket-modal__error" *ngIf="supportForm.get('message')?.touched && supportForm.get('message')?.errors?.['required']">
          Message is required
        </div>
      </div>

      <div class="support-ticket-modal__field">
        <label class="support-ticket-modal__label" for="attachment">Attachment (Optional)</label>
        <div class="support-ticket-modal__file-container">
          <button 
            type="button"
            class="support-ticket-modal__file-label"
            supportTicketUpload>
            Choose File
          </button>
          <span class="support-ticket-modal__file-text">
            {{ uploadedFile ? uploadedFile.filename : 'No file chosen' }}
          </span>
        </div>
        <div class="support-ticket-modal__file-info" *ngIf="uploadedFile">
          <small class="support-ticket-modal__file-success">✓ File uploaded successfully</small>
        </div>
      </div>

      <button 
        type="submit" 
        class="support-ticket-modal__submit"
        [disabled]="isSubmitted || supportForm.invalid">
        <mat-spinner 
          *ngIf="isSubmitted" 
          class="support-ticket-modal__spinner"
          diameter="20">
        </mat-spinner>
        <span *ngIf="!isSubmitted">Submit</span>
        <span *ngIf="isSubmitted">Submitting...</span>
      </button>
    </form>
  </div>

  <div class="support-ticket-modal__success" *ngIf="isSuccess">
    <div class="support-ticket-modal__success-content">
      <div class="support-ticket-modal__success-icon-container">
        <mat-icon class="support-ticket-modal__success-icon">check_circle</mat-icon>
      </div>
      <h3 class="support-ticket-modal__success-title">Support Ticket Created!</h3>
      <p class="support-ticket-modal__success-message">
        Thank you for contacting us. We'll get back to you shortly.
      </p>
      <div class="support-ticket-modal__ticket-reference">
        <span class="support-ticket-modal__reference-label">Reference ID:</span>
        <span class="support-ticket-modal__reference-value">{{ ticketReference || 'Loading...' }}</span>
      </div>
      <button 
        color="primary" 
        class="support-ticket-modal__close-button"
        (click)="onClose()">
        Close
      </button>
    </div>
  </div>
</div>
